import { render, staticRenderFns } from "./FolderTree.vue?vue&type=template&id=7f8727fe&scoped=true"
import script from "./FolderTree.vue?vue&type=script&lang=js"
export * from "./FolderTree.vue?vue&type=script&lang=js"
import style0 from "./FolderTree.vue?vue&type=style&index=0&id=7f8727fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8727fe",
  null
  
)

export default component.exports